'use client'

import React, { useState, useRef, ReactNode } from 'react'

type RenderProps = {
  isMouseOverElement: boolean
}

type Props = {
  children: (props: RenderProps) => ReactNode
  delay?: number
}

const DEFAULT_DELAY_MS = 300

const HoverDelay = ({ children, delay = DEFAULT_DELAY_MS }: Props) => {
  const [isMouseOverElement, setIsMouseOverElement] = useState(false)
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null)

  const handleMouseEnter = () => {
    if (!isMouseOverElement) {
      timeoutIdRef.current = setTimeout(() => setIsMouseOverElement(true), delay)
    }
  }

  const handleMouseLeave = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current)
      timeoutIdRef.current = null
    }

    setIsMouseOverElement(false)
  }

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {children({ isMouseOverElement })}
    </div>
  )
}

export default HoverDelay
